import { render } from "./MyPageNumberInput.vue?vue&type=template&id=c182af9e&ts=true"
import script from "./MyPageNumberInput.vue?vue&type=script&lang=ts"
export * from "./MyPageNumberInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
